'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('ifeis.toolbar', ['ngMaterial']).directive('fToolbar', function () {
  var fToolbar = {
    restrict: 'AE',
    controller: 'ToolbarController',
    template: require('./tpl.html'),
    replace: true,
    scope: {
      title: '@'
    },
    link: function link(scope, element, attrs) {
      scope.isCardLayout = 'toolbarForCard' in attrs;
    }
  };

  return fToolbar;
}).controller('ToolbarController', function ($scope, $mdSidenav, fSession) {
  $scope.toggleLeftNav = function () {
    $mdSidenav('left').toggle();
  };

  $scope.fSession = fSession;
});


//////////////////
// WEBPACK FOOTER
// ./toolbar/index.js
// module id = 146
// module chunks = 0